import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import UserContext from '../../../components/User_Context.js';
import * as menu from "../../../assets/menus/menu.js";
import * as breadcrumb from "../../../components/ui/breadcrumb.js";
import * as api from "../../../api/apiConnector.js";
import { useTranslation } from 'react-i18next';
import { dms_style } from "../../../styles/style.js";
import { formBuilderLabels } from '../../_label/form_builder/form_builder_labels.js';

const Forms_DashBoard = () => {
    const { currentUser } = useContext(UserContext);
    const [forms, setForms] = useState(null); // State to store the list of forms
    const { t } = useTranslation();
    const { formId } = useParams();

    // Initialize translations from centralized file and set up component
    useEffect(() => {
        const i18n = menu.getI18n();
        i18n.addResourceBundle('it', 'labels', formBuilderLabels.it, true, true);
        i18n.addResourceBundle('en', 'labels', formBuilderLabels.en, true, true);

        menu.write({ user: currentUser() });

        // Set breadcrumb using translations
        breadcrumb.set([
            { link: "/", name: t('home', { ns: 'labels' }) },
            { link: "/form_builder/dashboard", name: t('formsDashboard', { ns: 'labels' }) }
        ]);

        getFilteredData();
    }, [formId]);

    // Fetch form data from the backend
    const getFilteredData = async () => {
        try {
            const body = {};
            if (formId) {
                body.formId = formId;
            }
            const result = await api.sendMessage("darm/formCompletion/getFormsPerUser", {
                user: currentUser(),
                body: body
            });

            if (result) {
                setForms(result);
            }
        } catch (error) {
            console.error("Error loading forms:", error);
        }
    };

    // TableCard component to render each category of forms
    const TableCard = ({ label, labelKey, list = [], isClickable = false }) => {
        const { t } = useTranslation();
        const [collapsed, setCollapsed] = useState(list.length === 0);

        // Function to handle row click
        const handleRowClick = (item) => {
            if (isClickable) {
                // Navigate to /form/compile/{formId}/{completionId}
                // item.FormId is the original form ID, item.Id is the completion ID
                window.location.href = `/form/compile/${item.FormId}/${item.Id}`;
            }
        };

        // Determine cursor style based on clickability
        const getCursorStyle = () => isClickable ? 'pointer' : 'default';

        return (
            <div className="card mb-4" style={{ border: '2px solid #ffc107', borderRadius: '8px' }}>
                <div
                    className="card-header d-flex justify-content-between align-items-center"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <h5 className="mb-0 fw-semibold">{label} ({list.length})</h5>
                    <span>{collapsed ? '+' : '−'}</span>
                </div>

                {!collapsed && (
                    <div className="card-body">
                        <div style={{ minHeight: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {list.length > 0 ? (
                                <div className="w-100">
                                    {/* Desktop/Tablet */}
                                    <div className="d-none d-md-block" style={{ overflowX: 'auto', width: '100%' }}>
                                        <table className="table table-hover" style={{ minWidth: '900px', borderCollapse: 'separate', borderSpacing: '0 12px' }}>
                                            <thead>
                                                <tr className="text-muted" style={{ fontSize: '0.875rem' }}>
                                                    <th style={{ padding: '8px 16px', minWidth: '200px' }}>{t('Name', { ns: 'labels' })}</th>
                                                    <th style={{ padding: '8px 16px', minWidth: '250px' }}>{t('Description', { ns: 'labels' })}</th>
                                                    <th style={{ padding: '8px 16px', minWidth: '150px' }}>{t('Group', { ns: 'labels' })}</th>
                                                    <th style={{ padding: '8px 16px', minWidth: '100px' }}>{t('Code', { ns: 'labels' })}</th>
                                                    <th style={{ padding: '8px 16px', minWidth: '120px' }}>{t('Status', { ns: 'labels' })}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.map(item => (
                                                    <tr key={item.Id} style={{ backgroundColor: '#f8f9fa', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.05)' }}>
                                                        <td onClick={() => handleRowClick(item)} style={{ padding: '12px 16px', borderTopLeftRadius: '6px', borderBottomLeftRadius: '6px', cursor: getCursorStyle() }}>{item.formMeta?.Name}</td>
                                                        <td onClick={() => handleRowClick(item)} style={{ padding: '12px 16px', cursor: getCursorStyle() }}>{item.formMeta?.Description}</td>
                                                        <td onClick={() => handleRowClick(item)} style={{ padding: '12px 16px', cursor: getCursorStyle() }}>{item.formMeta?.Group}</td>
                                                        <td onClick={() => handleRowClick(item)} style={{ padding: '12px 16px', cursor: getCursorStyle() }}>{item.formMeta?.Code}</td>
                                                        <td onClick={() => handleRowClick(item)} style={{ padding: '12px 16px', cursor: getCursorStyle(), borderTopRightRadius: '6px', borderBottomRightRadius: '6px' }}>{item.Status}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Mobile */}
                                    <div className="d-block d-md-none responsive-table">
                                        {list.map(item => (
                                            <div key={item.Id} className="table-row-responsive" onClick={() => handleRowClick(item)} style={{ cursor: getCursorStyle() }}>
                                                <div className="table-cell-responsive"><strong>{t('Name', { ns: 'labels' })}:</strong> {item.formMeta?.Name}</div>
                                                <div className="table-cell-responsive"><strong>{t('Description', { ns: 'labels' })}:</strong> {item.formMeta?.Description}</div>
                                                <div className="table-cell-responsive"><strong>{t('Group', { ns: 'labels' })}:</strong> {item.formMeta?.Group}</div>
                                                <div className="table-cell-responsive"><strong>{t('Code', { ns: 'labels' })}:</strong> {item.formMeta?.Code}</div>
                                                <div className="table-cell-responsive"><strong>{t('Status', { ns: 'labels' })}:</strong> {item.Status}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <div className="text-muted text-center" style={{ fontSize: '0.95rem' }}>
                                    {t(`empty${labelKey}`, { ns: 'labels' })}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // Sum of all form types
    const totalForms =
        (forms?.assigned?.length || 0) +
        (forms?.saved?.length || 0) +
        (forms?.compiled?.length || 0) +
        (forms?.approved?.length || 0);


    return (
        <div className="container-fluid">

            {/* Dashboard header card */}
            <div className="card mb-3" style={{ border: '1px solid #dee2e6', borderRadius: '8px' }}>
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        <div>
                            <h4 className="card-title mb-1">{t('formsDashboard', { ns: 'labels' })}</h4>
                            <p className="mb-0">
                                {t('formsDashboardWelcome', { ns: 'labels' })}
                            </p>
                        </div>
                        {forms && (
                            <h5 className="mb-0">
                                {t('CompiledForms', { ns: 'labels' })}
                                {totalForms > 0 && (
                                    <span className="badge bg-warning ms-2">{totalForms}</span>
                                )}
                            </h5>
                        )}
                    </div>
                </div>
            </div>

            {/* Cards per each form status */}
            {forms ? (
                <>
                    <TableCard labelKey="Assigned" label={t("Assigned", { ns: "labels" })} list={forms.assigned} isClickable={true} />
                    <TableCard labelKey="Saved" label={t("Saved", { ns: "labels" })} list={forms.saved} isClickable={true} />
                    <TableCard labelKey="Compiled" label={t("Compiled", { ns: "labels" })} list={forms.compiled} isClickable={false} />
                    <TableCard labelKey="Approved" label={t("Approved", { ns: "labels" })} list={forms.approved} isClickable={false} />
                </>
            ) : (
                <div className="text-center p-4">
                    <p>{t('no_data_available', { defaultValue: 'No data to display.' })}</p>
                </div>
            )}

        </div>
    );

};

export default Forms_DashBoard;
